<template>
    <div id="header">
        <b-container>
            <b-row>
                <b-col>
                    <div id="logo">
                        <router-link :to="{ name: 'home' }"><img src="../assets/images/enviroSIGNSlogo.png" width="100%" alt="enviroSIGNS"/></router-link>
                    </div>
                    <div id="nav">
                        <Nav></Nav>
                    </div>
                </b-col>
            </b-row>
        </b-container>

    </div>
</template>

<script>
    import Nav from './Nav.vue'

    export default {
      components: {
        Nav
      }
    }
</script>

<style lang="scss">
    @import '../assets/css/header.scss';
</style>


// WEBPACK FOOTER //
// src/components/Header.vue